export enum DocumentationType {
  UserManual,
  CmxEmpty,
  CmxSolidworksExample,
  CmxTeklaExample,
  CmxTableTemplate,
  SteelworksMacro,
  TeklaCustomProperties,
  TeklaReportTemplate,
  CutFaceCutCase,
  SteelworksAddIn,
  WeldmentProfiles,
}

export interface LatestInstaller {
  version: string;
  releaseDate: string;
  size: number;
  fileName?: string;
}

export interface LatestUserManual {
  revision: string;
  fileName: string;
  size: number;
}
